import React from 'react';

// Counter to ensure unique mask IDs for each instance of ChatIcon
let chatIconMaskIdCounter = 0;

const ChatIcon = ({ fill = "#5E5E5E", className = "", width = "24", height = "24", ...props }) => {
    const uniqueMaskId = `chat_icon_mask_${chatIconMaskIdCounter++}`;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" className={className} {...props} aria-hidden="true">
            <mask
                id={uniqueMaskId}
                // Use kebab-case for the attribute name as a string key
                // to ensure it's rendered correctly in the DOM.
                // React will pass this through as mask-type="alpha".
                {...{ 'mask-type': 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0" y="0"
                width={width} height={height}
            >
                <rect width={width} height={height} fill="white" /> {/* Changed fill to white and use props for width/height */}
            </mask>
            <g mask={`url(#${uniqueMaskId})`}>
                <path d="M8 14H16V13.45C16 12.7167 15.6333 12.125 14.9 11.675C14.1667 11.225 13.2 11 12 11C10.8 11 9.83333 11.225 9.1 11.675C8.36667 12.125 8 12.7167 8 13.45V14ZM12 10C12.55 10 13.0208 9.80417 13.4125 9.4125C13.8042 9.02083 14 8.55 14 8C14 7.45 13.8042 6.97917 13.4125 6.5875C13.0208 6.19583 12.55 6 12 6C11.45 6 10.9792 6.19583 10.5875 6.5875C10.1958 6.97917 10 7.45 10 8C10 8.55 10.1958 9.02083 10.5875 9.4125C10.9792 9.80417 11.45 10 12 10ZM2 22V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H6L2 22ZM5.15 16H20V4H4V17.125L5.15 16Z" fill={fill} />
            </g>
        </svg>
    );
};

export default ChatIcon;